var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _vm.currentTab == 0
        ? _c(
            "app-dossier-info",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.goToCompanyToolTipText,
                      expression: "goToCompanyToolTipText",
                    },
                  ],
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.editDossierToolTipText,
                      expression: "editDossierToolTipText",
                    },
                  ],
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.editDossier()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTab == 1
        ? _c(
            "app-dossier-info-user",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.goToCompanyToolTipText,
                      expression: "goToCompanyToolTipText",
                    },
                  ],
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.editDossierToolTipText,
                      expression: "editDossierToolTipText",
                    },
                  ],
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.editDossier()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTab == 2
        ? _c(
            "app-dossier-info-scripts",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.goToCompanyToolTipText,
                      expression: "goToCompanyToolTipText",
                    },
                  ],
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.editDossierToolTipText,
                      expression: "editDossierToolTipText",
                    },
                  ],
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.editDossier()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTab == 3
        ? _c(
            "app-dossier-calculated-fields-info",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.goToCompanyToolTipText,
                      expression: "goToCompanyToolTipText",
                    },
                  ],
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "div",
                [
                  _c(
                    "w-col",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.editDossierToolTipText,
                              expression: "editDossierToolTipText",
                            },
                          ],
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.editDossier()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTab == 4
        ? _c(
            "app-dossier-browse-extra-button-info",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.goToCompanyToolTipText,
                      expression: "goToCompanyToolTipText",
                    },
                  ],
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "div",
                [
                  _c(
                    "w-col",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.editDossierToolTipText,
                              expression: "editDossierToolTipText",
                            },
                          ],
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.editDossier()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }